import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 10,
	viewBox: "0 0 14 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M4.86205 9.59481C4.78723 9.59229 4.71372 9.57452 4.64602 9.54259C4.57832 9.51065 4.51786 9.46523 4.46833 9.4091L0.754046 5.69481C0.683228 5.6489 0.623767 5.58749 0.580153 5.51523C0.536539 5.44298 0.509912 5.36175 0.502282 5.2777C0.494651 5.19364 0.506218 5.10895 0.536107 5.03002C0.565996 4.95109 0.613428 4.87998 0.67482 4.82207C0.736212 4.76415 0.809961 4.72094 0.890497 4.69569C0.971034 4.67045 1.05625 4.66383 1.13972 4.67634C1.22319 4.68885 1.30272 4.72016 1.37232 4.7679C1.44192 4.81565 1.49976 4.87858 1.54147 4.95195L4.86205 8.25024L12.6398 0.494812C12.7445 0.426921 12.8689 0.396151 12.9932 0.407434C13.1175 0.418716 13.2344 0.471397 13.3252 0.557033C13.416 0.642669 13.4753 0.756301 13.4938 0.879716C13.5123 1.00313 13.4889 1.12918 13.4272 1.23767L5.25576 9.4091C5.20624 9.46523 5.14577 9.51065 5.07807 9.54259C5.01037 9.57452 4.93686 9.59229 4.86205 9.59481Z" })]
});
const ForwardRef = forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
